import { GRAMMAR, PLAGIARISM } from '@src/components/Cards/constants'
import { CheckCategory, EXPERT_CHECK } from '@src/state/document/types'
import { getWorkspacePath } from '@src/utils/routes'
import { EC_BASE_SLUG, PLAGIARISM_SLUG } from '../types'

interface GetCheckCategoryPathParams {
  paperId: string
  checkCategory: CheckCategory
  ecPageSlug?: string
  isDemo?: boolean
}
export const getCheckCategoryPath = ({
  paperId,
  checkCategory,
  ecPageSlug,
  isDemo = false,
}: GetCheckCategoryPathParams): string => {
  const basePath = getWorkspacePath(paperId, isDemo)
  switch (checkCategory) {
    case GRAMMAR:
      return basePath
    case PLAGIARISM:
      return basePath + PLAGIARISM_SLUG
    case EXPERT_CHECK: {
      return (
        basePath +
        (!isDemo && ecPageSlug ? `${EC_BASE_SLUG}/${ecPageSlug}` : EC_BASE_SLUG)
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/layouts/shared/NavTabs/utils/index.tsx